export enum CalculationStatus {
    PENDING = 'pending',
    QUEUED = 'queued',
    CALCULATING = 'calculating',
    COMPLETED = 'completed',
    FAILED = 'failed',
}
